<div class="c-rating" title="{{vm.model && vm.model + '/' + vm.maxRating}}">
	<div class="c-rating__group" *ngFor="let rating of vm.ratings ; let $index=index">
		<div class="c-rating__label" [ngClass]="{'c-rating__label--sm': vm.size === 'sm', 'c-rating__label--lg': vm.size === 'lg', 'c-rating__label--active': vm.roundValue >= (vm.ratings?.length - $index)}">
			<i class="o-icon o-icon--star" aria-hidden="true"></i>
		</div>
		<div class="c-rating__label c-rating__label--half" [ngClass]="{'c-rating__label--sm': vm.size === 'sm', 'c-rating__label--lg': vm.size === 'lg', 'c-rating__label--active': vm.roundValue >= (vm.ratings?.length - $index - 0.5)}">
			<i class="o-icon o-icon--star" aria-hidden="true"></i>
		</div>
	</div>
</div>
